import React from "react";
import PropTypes from "prop-types";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
} from "@mui/material";
import dayjs from "dayjs";

const BondArchivesBypassHistoryDialog = ({
  bypassHistoryDialogOpen,
  setBypassHistoryDialogOpen,
  bypassHistorySearch,
  setBypassHistorySearch,
  bypassHistoryLoading,
  bypassHistoryList,
}) => {
  return (
    <Dialog
      open={bypassHistoryDialogOpen}
      onClose={() => setBypassHistoryDialogOpen(false)}
      maxWidth="md"
      fullWidth
      slotProps={{ paper: { sx: { maxHeight: "90vh" } }}}
    >
      <DialogTitle sx={{ fontWeight: 700 }}>Liberty Bypass History</DialogTitle>
      <DialogContent dividers>
        <TextField
          size="small"
          placeholder="Search by bond #, type, estate, law firm, bypassed by..."
          value={bypassHistorySearch}
          onChange={(e) => setBypassHistorySearch(e.target.value)}
          fullWidth
          sx={{ mb: 2 }}
        />
        {bypassHistoryLoading ? (
          <Box display="flex" justifyContent="center" py={4}>
            <CircularProgress />
          </Box>
        ) : (
          <TableContainer sx={{ maxHeight: 420 }}>
            <Table size="small" stickyHeader>
              <TableHead>
                <TableRow sx={{ "& th": { backgroundColor: "#f5f5f5", fontWeight: 600 } }}>
                  <TableCell>Bond #</TableCell>
                  <TableCell>Bond Type</TableCell>
                  <TableCell>Sub Category</TableCell>
                  <TableCell>Estate</TableCell>
                  <TableCell>Law Firm</TableCell>
                  <TableCell>Bypassed By</TableCell>
                  <TableCell>Bypassed At</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {(() => {
                  const q = (bypassHistorySearch || "").toLowerCase().trim();
                  const filtered = q
                    ? bypassHistoryList.filter((row) => {
                      const s = [
                        row.bond_number,
                        row.bond_type,
                        row.bond_sub_category,
                        row.estate_name,
                        row.lawfirm_name,
                        row.bypassed_by,
                        row.bypassed_at,
                      ]
                        .filter(Boolean)
                        .join(" ")
                        .toLowerCase();
                      return s.includes(q);
                    })
                    : bypassHistoryList;
                  return filtered.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={7} align="center" sx={{ py: 3, color: "text.secondary" }}>
                        {bypassHistoryList.length === 0 ? "No bypass history yet." : "No matches for your search."}
                      </TableCell>
                    </TableRow>
                  ) : (
                    filtered.map((row, idx) => (
                      <TableRow
                        key={row.id ?? `${row.bond_number}-${row.bypassed_at}-${idx}`}
                        hover
                      >
                        <TableCell>{row.bond_number ?? "—"}</TableCell>
                        <TableCell>{row.bond_type ?? "—"}</TableCell>
                        <TableCell>{row.bond_sub_category ?? "—"}</TableCell>
                        <TableCell>{row.estate_name ?? "—"}</TableCell>
                        <TableCell>{row.lawfirm_name ?? "—"}</TableCell>
                        <TableCell>{row.bypassed_by ?? "—"}</TableCell>
                        <TableCell>
                          {row.bypassed_at ? dayjs(row.bypassed_at).format("MMM D, YYYY h:mm A") : "—"}
                        </TableCell>
                      </TableRow>
                    ))
                  );
                })()}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setBypassHistoryDialogOpen(false)} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

BondArchivesBypassHistoryDialog.propTypes = {
  bypassHistoryDialogOpen: PropTypes.bool.isRequired,
  setBypassHistoryDialogOpen: PropTypes.func.isRequired,
  bypassHistorySearch: PropTypes.string.isRequired,
  setBypassHistorySearch: PropTypes.func.isRequired,
  bypassHistoryLoading: PropTypes.bool.isRequired,
  bypassHistoryList: PropTypes.array.isRequired,
};

export default BondArchivesBypassHistoryDialog;
